import styled from 'styled-components/macro';
import { colour, fontSize, lineHeight } from '@notonthehighstreet/toolkit/utils';
import { mediaQuery } from '../../styles/utils';

export const AccountItems = styled.ul({
  display: 'block',
  width: '100%',
  listStyleType: 'none',
  padding: 0,
});

export const AccountItem = styled.li({
  '& a': {
    display: 'inline-block',
    width: '180px',
  },
});

export const Container = styled.div({
  padding: '20px',
  marginRight: '20px',
  display: 'none',
  [mediaQuery('tablet')]: {
    marginTop: '20px',
    display: 'block',
    boxSizing: 'border-box',
    position: 'relative',
    padding: '23px',
    background: colour('pampas'),
    border: `1px solid ${colour('timberwolf')}`,
    height: '50%',
    maxWidth: '224px',
    '& a': {
      color: colour('emperor'),
      textDecoration: 'none',
      fontSize: fontSize('s'),
      lineHeight: lineHeight('l'),
      '&:hover': {
        color: colour('cerulean'),
        cursor: 'pointer',
      },
    },
    '& .active': {
      fontWeight: 'bold',
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      left: '-2px',
      top: '-1px',
      right: '8px',
      bottom: '-1px',
      zIndex: '-1',
      display: 'block',
      transform: 'rotate(3.3deg)',
      background: colour('venice-blue'),
    },
  },
});

export const Title = styled.h1({
  fontSize: fontSize('l'),
  textTransform: 'lowercase',
  color: colour('tundora'),
  marginBottom: '16px',
  marginTop: '0px',
  fontWeight: 'normal',
});
